export default import.meta.ROLLUP_FILE_URL_PazdwOsUw4Gom6iYrpcuFw